import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { gameListJson } from '@/views/system/homePage/server';
import { GetMustPlayGamesJson } from '@/views/system/homePage/components/boxMustPlayServer/service';
import { JXitemJson } from '@/views/system/homePage/server';
import { openListJson } from '@/views/system/homePage/server';
import { BannerItem, SelectGameItem } from '@/views/system/homePage/playful/service';

export interface HomePagesState extends gameListJson {
  timeOut: number;
  scrollTop: number;
  loading: boolean;
  mustPlayList: GetMustPlayGamesJson[];
  boxOpenList: openListJson[];
  clientTime: number;
  mTime: number;
  popularGame: GetMustPlayGamesJson[];
  JXlist: JXitemJson[];
  playfulBanner: BannerItem[];
  playfulSelectedGame: SelectGameItem[];
  playfulJXlist: JXitemJson[];
}

const HOMEPAGE_KEY = 'React-ts-ant-homePage';

const localHomePages = LocalStore.getValue<HomePagesState>(HOMEPAGE_KEY) || {};

// 顶层：defaults 对象
export const defaults: HomePagesState = {
  banner_list: [],
  game_popular: [],
  game_popular_new: [],
  game_recommend: [],
  timeOut: 0,
  scrollTop: 0,
  loading: true,
  mustPlayList: [],
  boxOpenList: [],
  clientTime: 0,
  mTime: 0,
  repair_tool_url: '', // 新增：修复工具地址的默认值
  popularGame: [],
  JXlist: [],
  playfulBanner: [],
  playfulSelectedGame: [],
  playfulJXlist: [],
  ...localHomePages
};

const HOME_PAGE_KEY = 'React-ts-ant-HOMEPAGES';

export const updateHomePages: (homePages: HomePagesState) => IAction<HomePagesState> = (homePages: HomePagesState) => ({
  type: HOME_PAGE_KEY,
  payload: homePages
});

const homePageReducer: Reducer<HomePagesState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_PAGE_KEY:
      LocalStore.setValue(HOMEPAGE_KEY, payload as HomePagesState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homePageReducer;
